import { render, staticRenderFns } from "./PointsBalanceLock.vue?vue&type=template&id=f0eee8fa"
import script from "./PointsBalanceLock.vue?vue&type=script&lang=js"
export * from "./PointsBalanceLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports